import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { ratePlanCodes, networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'beIN Sports',
    callsign: 'BEIN1HD',
    logoUrl: networkLogos.bein.logoUrl,
    slug: 'latino',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="latino"
        callsign="BEIN1HD"
        title="Watch beIN Sports live with Fubo"
        offerCode={ratePlanCodes.latino}
        networkSet="entertainmentLatino"
        networkName="beIN Sports"
      />
    </>
  )
}
